var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1442_40316",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1442_40316",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAFD0lEQVR4nO2dXYhVVRTHfzM6Zl0zdbJRcwysLKgHmyKolyiop6igDzTsi6RCK+yprIcegpAiqOjzIaggKIoysyAqNfMhCqohyAgVTZvwK2fSq404c3pYc6Dkzp17zt1r7XP22T/4v83cs9b6c8++Z++194FIJBKJRCKRSPGZATwGfAccBf4B+oEngJrHuCrJrcA+IBlHvwJzvUVXISYDaxjfiP9qC9DpJ8xqMAvYRGtmpFrpJdIKcC5yG8piRgIcGfvfiEOupPl4MZE2AB3mUQfKMuTXU14zUt1vHXiI3AuM0L4Z6a1roW34YbEcd2ak+op468rFEmAUt2akWm6YRxBcCtTRMSMBhoAFZtmUnLnAAHpmpPrMKqGy8wn6ZqS6xyin0nItdmYkwCHgbJPMSso6bA1JgPUmmZWUg9gbkgB3WCRXRo7gx5CDxGn6huzAjyEJ8mMichLf4s+QBLhdP8Vy8TZ+DTkA9KhnWTCard79aBZFY7qBhz3HUCiuwu83JAG2qWdZMJrNtJ6C3DamGcXSiLrn65vT7JY1jKyX+6Tu+frmTNQB4nvSr9/z9QvHbOA4/saQB/RTLB9r8WPGEHC6QX6FopWmtbfUo2jMs8BhT9cuNJOA7dh+O/YAp1kkV1YewdaQZTZplZfpyAKShRnfU+H+30kt/t0w0AVcoxhLylJgp8F1Ss80YC+6344PzLIJhFXomTEMnGeXShhMIV/Heyt6xTCPoNDqRtmF7DeJ5OBj9MaQ2Oubg3nAIDqmrDbMIyhWomPICHC9YR7B0AlsRseUQeAiu1TCYT56DXV7gF67VMLhZnQMSYCfkcMIIhl5Az1TNiLr+5EM1NB7YEyAd2l93i0yRh8y/aFlyptUeBY4Lw+iZ0iCTK/EB8eMvI6uKc/bpRIGXWQ//ySrnjLLJhB6gN/RNWWNWTaBsBjd7dQJ8DJxTMnEUvQOHEj1KvHXVyYeR9eQBHgHOUgt0iIvoW/Ke8iKZqQFOoH30TdlA3CGUU6lZyrwNfqm9JP/AILpwEPAl8gsdh3Z/Po0cFbOzyw0M5EZXG1TdpFtPaUGPIn0Eo/3mfuRU5GCowfYir4pfwM3TRBLB3K87c4Mn7ueAI8A6cVmH/wo8gDZ6FnlauCHnJ97CLjPSSUKxEJgN/qmJEg3S7rQtQh3e17WIQ0fwXAB8Cc2puwAXsP9jrC/gLtcF8YnF9PekbNF0adIj0EQXAj8gf+itqshZGwJYn5tEXZjirY+J5BzJM9BTm/wXVAXqgOPEsDEZy/wG/4L6kqbgfOdVsgD87B5orfSYWAFJR9bZmAz92WpjcAcl0WyZiryUOe7kC61lSavfyp689kJxJBu4HLPsbjiTGTA/8Z3IO2yGv3lYCv95Lg23liCvP3Nd0Hb1VHXhfFJH/otRtoadF4Vz/Qg92Dfhc2rLe5L4p/JwIv4L24erVKoR2FYgZt3YllpgAqcA7YYm2XhdjUK3KhUg8JxKvAC/oveTM+oZV9gbkFW8XwX/2R9QYW7KxegvyUii34hbl6lA1m9G8KvGfuJpxz9j/nAR/gx4xhwhX6K5eQ65NZhZcYJ4DaTzEpMF7IxVbv1aAS40yinIKgh690ax4KMAHfbpRIWNWTgd/VQeYxAG7Kt6QRuAD4k/+EHA8Bl1oFXgW7kXe9rab49IdUocsrEbBcXL3UXhAFTkKXjPuASpJlvzpiOI0sAzyHNGJFIJBKJRCKRwvIvlmaEfK2gJfwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.7bafe9ce82c4113f782561809379dbcb.svg";
export { ForwardRef as ReactComponent };